import {Nav, Tab} from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import ProfileBanner from "../../components/Profile/Banner";
import {Link, useLocation} from "react-router-dom";
import ProfileForm from "../../components/Profile/profileForm";
import ProfileDiplomes from "../../components/Profile/profileDiplome";
import ProfileZones from "../../components/Profile/ProfileZones";
import ProfileExpertise from "../../components/Profile/profileExpertise";
import {useEffect, useState} from "react";
import {useClient, useMe, useTechnician} from "../../../hooks/useGetUser";
import Loader from "../../components/shared/Loader";
import {accountStatus, userRoleList} from "../../../utils/constants";
import AllReviewTable from "../../components/Dashboard/acara/dashboardTable/Reviews/AllReviewTable";
import {useUpdateTechnician} from "../../../hooks/useUpdateUser";
import HeadBanner from "./HeadBanner";
import ListReviews from "../../components/Profile/ListReviews";
import QueryErrorState from "../../components/shared/QueryErrorState";
import {getDateLocale} from "../../../utils/date";

const ProfileClientPage = () => {
  const [activeTab, setActiveTab] = useState("avis");
  const {data, isLoading, isError, error, refetch} = useClient();

  if (isLoading) {
    return <Loader />;
  }
  if (isError) {
    return <QueryErrorState error={error} onRetry={refetch} />;
  }

  const {reviews} = data?.User;
  return (
    <>
      {/* <PageTitle activeMenu="Mon profil" /> */}
      <div className="w-full flex flex-col px-1 lg:grid lg:grid-cols-4 gap-4">
        <HeadBanner data={data} />
        <div className="col-span-3 w-full bg-white !py-5 !px-6 rounded-xl">
          <div className="profile-tab">
            <div className="custom-tab-1">
              <Tab.Container
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
              >
                <Nav as="ul" className="nav nav-tabs">
                  <Nav.Item as="li" i className="nav-item">
                    <Nav.Link eventKey="avis">Évaluations</Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="avis">
                    <div className="w-full px-1 py-11 flex flex-col gap-5 justify-start items-start">
                      <div className="text-left font-bold text-xl text-[#19295C]  ">
                        Liste des évaluations
                      </div>
                      {!!reviews?.length ? (
                        <ListReviews reviews={reviews} />
                      ) : (
                        <div className="text-base text-[#7e7e7e]">
                          Pas d'évaluations
                        </div>
                      )}
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col justify-start items-start gap-3">
          <div className="w-full bg-white !rounded-lg flex gap-3 flex-col 2xl:!px-4 px-4 lg:!px-3 !py-4 ">
            <div className="text-left font-bold text-base  text-[#19295C] mb-1 ">
              Vérifications
            </div>

            <div className="w-full flex justify-between items-center">
              <span className="font-semibold text-[13px]  leading-4 text-[#7e7e7e] ">
                Adresse mail
              </span>

              {!!data?.User?.verifiedEmail ? (
                <div className="flex gap-1 text-[#27AA00] font-semibold text-xs">
                  <span className="text-xs">Vérifiée </span>
                  <i className="fi fi-ss-check-circle flex items-center"></i>
                </div>
              ) : (
                <div className="flex gap-1 text-[#FF0000] font-semibold text-xs">
                  <span className="text-xs ">Non Vérifiée </span>
                  <i className="fi fi-ss-circle-xmark flex items-center"></i>
                </div>
              )}
            </div>
            <div className="w-full flex justify-between items-center">
              <span className="font-semibold text-[13px]  leading-4 text-[#7e7e7e] ">
                Numéro de téléphone
              </span>

              <div className="flex gap-1 text-[#27AA00] font-semibold text-xs">
                <span className="text-xs">Vérifié </span>
                <i className="fi fi-ss-check-circle flex items-center"></i>
              </div>
            </div>
          </div>

          {/* <div className="w-full bg-white !rounded-lg flex gap-5 flex-col px-4 py-6 ">
            <div className="text-left font-bold text-lg text-[#19295C] mb-1 ">
              Statistiques
            </div>
            <div className="w-full flex justify-between items-center">
              <span className="font-semibold text-[15px] lg:text-[12px] 2xl:text-[15px] lg:leading-3 2xl:leading-4 leading-4 text-[#7e7e7e] ">
                Interventions réalisées
              </span>

              <div className="flex justify-end gap-1 text-[#19295C] font-semibold text-[14px] lg:text-[12px] 2xl:text-[14px] lg:leading-3 2xl:leading-4">
                15
              </div>
            </div>
            <div className="w-full flex justify-between items-center">
              <span className="font-semibold text-[15px] lg:text-[12px] 2xl:text-[14px] lg:leading-3 2xl:leading-4 leading-4 text-[#7e7e7e] ">
                Interventions réussies
              </span>

              <div className="flex justify-end gap-1 text-[#19295C] font-semibold text-[15px] lg:text-[12px] 2xl:text-[15px] lg:leading-3 2xl:leading-4">
                90%
              </div>
            </div>
            <div className="w-full flex justify-between items-center">
              <span className="font-semibold text-[15px] lg:text-[12px] 2xl:text-[15px] lg:leading-3 2xl:leading-4 leading-4 text-[#7e7e7e] ">
                Membre depuis
              </span>

              <div className="flex justify-end gap-1 text-[#19295C] font-semibold text-[15px] lg:text-[12px] 2xl:text-[15px] lg:leading-3 2xl:leading-4">
                {new Date(data?.createdAt)
                  .toLocaleDateString(getDateLocale(), {
                    month: "short",
                    year: "numeric",
                  })
                  .replace(".", "")}
              </div>
            </div>
            <div className="w-full flex justify-between items-center">
              <span className="font-semibold text-[15px] lg:text-[12px] 2xl:text-[15px] lg:leading-3 2xl:leading-4 leading-4 text-[#7e7e7e] ">
                Profil vu
              </span>

              <div className="flex justify-end gap-1 text-[#19295C] font-semibold text-[15px] lg:text-[12px] 2xl:text-[15px] lg:leading-3 2xl:leading-4">
                {data?.viewCount ?? 0}
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default ProfileClientPage;
